import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "./Slider.module.css";

import Fade from 'react-reveal/Fade';

import slideImg1 from "../../images/tech.jpg";
import slideImg2 from "../../images/customers.jpg";
import slideImg3 from "../../images/impact.jpg";
import slideImg4 from "../../images/solution.jpg";
import arrowSmall from "../../images/arrow-small.svg";

import logo from "../../images/CVE_logo_shadow.svg";

import Slide from "./Slide/Slide";

export default class Slider extends Component {
  state = {
    slides: [
      {
        title: "The Finest Environment for our Fish",
        description:
          "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat invidunt ut labore et dolore magna aliquyam erat",
        linkText: "more about our clean technology",
        image: slideImg1,
        url: "/technology"
      },
      {
        title: "The Finest Catfish for our Customers",
        description:
          "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat invidunt ut labore et dolore magna aliquyam erat",
        linkText: "more about our wholesome products",
        image: slideImg2,
        url: "/customers"
      },
      {
        title: "Positive Environmental, Human and Social Impact",
        description:
          "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat invidunt ut labore et dolore magna aliquyam erat",
        linkText: "more about our POSITIVE IMPACT",
        image: slideImg3,
        url: "/impact"
      },
      {
        title: "A Local Solution to a Global Challenge",
        description:
          "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat invidunt ut labore et dolore magna aliquyam erat",
        linkText: "more about our Global presence",
        image: slideImg4,
        url: "/solution"
      }
    ],
    currentIndex: 0,
    translateValue: 0
  };

  handlePrevSlide = () => {
    //Sroll to End if at the beginning of Slider
    if (this.state.currentIndex === 0) {
      return this.setState({
        currentIndex: this.state.slides.length - 1,
        translateValue: (this.state.slides.length - 1) * -100
      })
    }

    this.setState(prevState => ({
      currentIndex: prevState.currentIndex - 1,
      translateValue: prevState.translateValue + 100
    }))
  }

  handleNextSlide = () => {
    // Reset if at end of slider
    if (this.state.currentIndex === this.state.slides.length - 1) {
      return this.setState({
        currentIndex: 0,
        translateValue: 0
      })
    }

    this.setState(prevState => ({
      currentIndex: prevState.currentIndex + 1,
      translateValue: prevState.translateValue - 100
    }))
  }

  render() {
    let indicator = this.state.currentIndex + 1;
    return (
      <div className={styles.Slider}>
        <div className={styles.SliderWrapper}
          style={{
            transform: `translateX(${this.state.translateValue}vw)`,
            transition: 'transform ease-out 0.45s'
          }}
        >
          {this.state.slides.map(
            ({ title, description, linkText, image, url }, index) => (
              <Slide
                title={title}
                description={description}
                linkText={linkText}
                image={image}
                key={index}
                url={url}
              />
            )
          )}
        </div>
        <Link to="/">
          <Fade>
            <img className={styles.logo} src={logo} alt="logo" />
          </Fade>
        </Link>
        <div className={styles.Indicator}>
          <Fade bottom delay={200}>
          <p>0{indicator}</p>
          <div className={styles.IndicatorBar}>
            <div style={{ width: `${(indicator / 4) * 100}%`, backgroundColor: 'white', height: '6px', transition: 'width 0.4s ease-out' }}></div>
          </div>
          <p>04</p>
          </Fade>
        </div>
        <div className={styles.Controls}>
          <Fade delay={400}>
          <button className={styles.leftArrow} onClick={this.handlePrevSlide}>
            <img src={arrowSmall} alt="left-arrow" />
          </button>
          <div>
            {
              [...Array(4)].map((_, index) => {
                if (index === (indicator - 1)) {
                  return <div key={index} style={{ width: '15px', transition: 'width 0.1s ease-out' }} />
                } else {
                  return <div key={index} />
                }
              })
            }
          </div>
          <button className={styles.leftArrow} onClick={this.handleNextSlide}>
            <img style={{ transform: 'rotate(180deg)' }} src={arrowSmall} alt="right-arrow" />
          </button>
          </Fade>
        </div>
      </div>
    );
  }
}
